import * as React from "react";
import styled from "styled-components";
import { ClubJudgeSearchPanel } from "./ClubJudgeSearchPanel";
import { ClubJudgeSavePanel, IClubJudgeSavePanelProps } from "./ClubJudgeSavePanel";
import { PanelStack, Classes, IPanel } from "@blueprintjs/core";
import { ETLCodes } from "../../../../../locales";
import { useTl } from "../../../../../hooks";
import { JudgeGridDto } from "../../../../../api";

export interface IClubJudgesPanelStackProps extends Pick<IClubJudgeSavePanelProps, "onSaved"> {
  clubId: number;
}

const Container = styled.div`
  flex: 1;
  height: 100%;
  & > .${Classes.PANEL_STACK} {
    height: 100%;
  }
`;

export const ClubJudgesPanelStack: React.FunctionComponent<IClubJudgesPanelStackProps> = ({ clubId, onSaved }) => {
  const { t } = useTl();
  const onSectionSelected = React.useCallback(
    (data: JudgeGridDto) => {
      setPanelStack((currentStack) => [
        ...currentStack,
        {
          component: () => <ClubJudgeSavePanel onSaved={onSaved} judge={data} clubId={clubId}/>,
        },
      ]);
    },
    [clubId, onSaved]
  );

  const [panelStack, setPanelStack] = React.useState<IPanel[]>([
    {
      component: () => (
        <ClubJudgeSearchPanel onPersonSelected={onSectionSelected} clubId={clubId}/>
      ),
      title: t(ETLCodes.JurySelection),
    },
  ]);

  const removeFromPanelStack = React.useCallback(() => {
    setPanelStack((prev) => prev.slice(0, prev.length - 1));
  }, [setPanelStack]);

  return (
    <Container>
      <PanelStack stack={panelStack} showPanelHeader={true} onClose={removeFromPanelStack}/>
    </Container>
  );
};
